import { styled } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'
import { theme } from 'highcharts'

export interface ButtonCustomProps extends ButtonProps {
  textColor?: string
  backgroundColor?: string
  borderColor?: string
}

// For a default button (no variant specified):
// color falls back to theme.palette.primary.main
// backgroundColor falls back to theme.palette.background.paper
// For a contained button:
// color falls back to theme.palette.primary.contrastText
// backgroundColor falls back to theme.palette.primary.main
// For an outlined button:
// color falls back to theme.palette.primary.main
// backgroundColor falls back to transparent
export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'textColor' &&
    prop !== 'backgroundColor' &&
    prop !== 'borderColor',
})<ButtonCustomProps>(
  ({
    size,
    textColor,
    borderColor,
    variant,
    backgroundColor,
    disabled,
    theme,
  }) => ({
    boxShadow: 'none',
    textTransform: 'none',
    height: size === 'small' ? '30px' : size === 'medium' ? '36px' : '40px',
    fontWeight: '500',
    fontSize: size === 'small' ? '13px' : size === 'medium' ? '14px' : '15px',
    lineHeight: size === 'small' ? '24px' : '22px',
    letterSpacing: size === 'medium' ? '0.4px' : '0.46px',
    color: textColor
      ? textColor
      : variant === 'outlined'
        ? theme.palette.buttons.outlined.color
        : variant === 'contained'
          ? theme.palette.buttons.contained.color
          : theme.palette.buttons.text.color,
    backgroundColor: backgroundColor
      ? backgroundColor
      : variant === 'outlined'
        ? theme.palette.buttons.outlined.backgroundColor
        : variant === 'contained'
          ? theme.palette.buttons.contained.backgroundColor
          : theme.palette.buttons.text.backgroundColor,
    border: borderColor
      ? `1px solid ${borderColor}`
      : variant === 'outlined'
        ? `1px solid ${theme.palette.buttons.outlined.color}`
        : undefined,
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
      backgroundColor:
        variant === 'contained' ? theme.palette.grey[100] : 'unset',
    },
    '&:hover': {
      color: textColor
        ? textColor
        : variant === 'contained'
          ? theme.palette.buttons.contained.hoverColor
          : variant === 'outlined'
            ? theme.palette.buttons.outlined.hoverColor
            : theme.palette.buttons.text.hoverColor,
      background: backgroundColor
        ? backgroundColor
        : variant === 'contained'
          ? `linear-gradient(0deg, ${theme.legacyColors.BLACK_30}, ${theme.legacyColors.BLACK_30}), ${theme.palette.buttons.contained.hoverBackgroundColor}`
          : variant === 'outlined'
            ? theme.palette.buttons.outlined.hoverBackgroundColor
            : theme.palette.buttons.text.hoverBackgroundColor,
      opacity: backgroundColor ? 10 : undefined,
      border: borderColor
        ? `1px solid ${borderColor}`
        : variant === 'outlined'
          ? `1px solid ${theme.palette.buttons.outlined.color}`
          : undefined,
    },
  }),
)
